import { FC } from "react";
import { Gender } from "@models/person";
import { FormControlLabel, Grid2 as Grid, Radio } from "@mui/material";
import ReactHookFormRadioButtonGroup from "@components/ReactHookFormRadioButtonGroup/ReactHookFormRadioButtonGroup";
import { Control } from "react-hook-form/dist/types/form";
import { useTranslation } from "react-i18next";

const GenderSelect: FC<{
  label: string;
  control: Control;
  name: string;
  required: boolean;
  error?: boolean;
}> = ({ label, control, required, name, error }) => {
  const { t } = useTranslation();
  return (
    <ReactHookFormRadioButtonGroup
      label={label}
      required={required}
      controller={{
        control,
        rules: { required },
        name,
        defaultValue: Gender.Male,
      }}
      error={error}
    >
      <Grid container spacing={0}>
        {Object.entries(Gender).map(([key, value]) => (
          <Grid key={key} size={12}>
            <FormControlLabel
              value={value}
              control={<Radio size="small" />}
              label={<>{t(`gender.${key.toLowerCase()}`)}</>}
            />
          </Grid>
        ))}
      </Grid>
    </ReactHookFormRadioButtonGroup>
  );
};

export default GenderSelect;
